import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
import { AuthClient } from '../auth/AuthClient';
import { getEnv } from '../config';
const EntitlementsContext = createContext(null);
export function EntitlementsProvider({ children }) {
    const [state, setState] = useState({ tools: [], loading: true, error: null });
    useEffect(() => {
        const token = AuthClient.getAccessToken();
        const baseUrl = getEnv('API_BASE_URL');
        fetch(`${baseUrl}/tools`, {
            headers: { Authorization: `Bearer ${token ?? ''}` }
        })
            .then(async (res) => {
            if (!res.ok)
                throw new Error(`Entitlements fetch failed: ${res.status}`);
            const body = (await res.json());
            setState({ tools: body.data.tools, loading: false, error: null });
        })
            .catch((err) => {
            setState({ tools: [], loading: false, error: err });
        });
    }, []);
    return _jsx(EntitlementsContext.Provider, { value: state, children: children });
}
export function useEntitlements() {
    const ctx = useContext(EntitlementsContext);
    if (!ctx)
        throw new Error('useEntitlements must be used inside EntitlementsProvider');
    return ctx;
}
